import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

import { withAllContextHoc } from "app/components/React/HOCs/withAllContextsHOC";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import { DigitalMarketingRedirectPage } from "app/pages/digital-marketing/home-pages/DigitalMarketingRedirectPage";
import { AcquisitionModuleHomePage } from "app/pages/digital-suite/AcquisitionHomepageComponent";
import { navigationTiles } from "app/pages/digital-suite/constants";
import { MarketResearchRoot } from "app/pages/market-research/MarketResearchRoot";
import { MarketResearchWrapper } from "app/pages/market-research/MarketResearchWrapper";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { backlinksConfig } from "./backlinksConfig";
import { keywordResearchConfig } from "./keywordResearchConfig";
import { searchConfig } from "./SearchConfig";

export const acquisitionConfig: RouterStateConfig = {
    digitalsuite_acquisition: {
        parent: "sw",
        abstract: true,
        packageName: "digitalsuite",
        url: "/digitalsuite/acquisition",
        component: withAllContextHoc(MarketResearchWrapper),
        configId: "AcquisitionAnalysisOverviewHome",
        secondaryBarType: "DigitalSuiteAcquisition" as SecondaryBarType,
        isSecondaryBarOpen: true,
        isSecondaryBar3Open: true,
        navBarContainerClassName: "accordion-side-bar",
    },
    digitalsuite_acquisition_root: {
        abstract: true,
        parent: "digitalsuite_acquisition",
        component: withAllContextHoc(MarketResearchRoot),
        secondaryBarType: "DigitalSuiteAcquisition" as SecondaryBarType,
        secondaryBarType3: SecondarySideBarType3.None,
    },
    "digitalsuite_acquisition-home": {
        parent: "digitalsuite_acquisition",
        url: "/home",
        component: withAllContextHoc(AcquisitionModuleHomePage),
        configId: "WebAnalysis",
        configIdDeps: [
            "PaidSearchOverview",
            "KeywordAnalysis",
            "KeywordAnalysisTotal",
            "MobileWebSearch",
            "SearchAds",
            "KeywordsAds",
            "KeywordAnalysisV2",
            "KeywordAnalysisMobileWeb",
            "SerpSnapshot",
            "KeywordsByGeo",
            "RankingDistribution",
        ],
        pageId: {
            section: "digitalmarketing",
            subSection: "homepage",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "Acquisition Channels/Home",
            subSubSection: "home",
        },
        pageTitle: "digitalmarketing.homepage.title",
    },
    acquisitionRedirect: {
        parent: "digitalsuite_acquisition",
        url: "/redirect/:id",
        component: () => <DigitalMarketingRedirectPage navigationTiles={navigationTiles} />,
        configId: "WebAnalysis",
        pageId: {
            section: "digitalmarketing",
            subSection: "redirect",
        },
        trackingId: {
            section: "Acquisition Channels",
            subSection: "redirect",
            subSubSection: "",
        },
        pageTitle: "digitalmarketing.homepage.title",
    },
    ...keywordResearchConfig,
    ...searchConfig,
    ...backlinksConfig,
};
